import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { trucks } from '../data/dummyData';

const TruckMatchPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedTruck, setSelectedTruck] = useState(location.state?.selectedTruck || null);
  const [filter, setFilter] = useState('all');
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [bookingStep, setBookingStep] = useState(0);
  const [pickup, setPickup] = useState('');
  const [delivery, setDelivery] = useState('');

  const filters = [
    { key: 'all', label: '전체' },
    { key: 'longDistance', label: '🛣️ 장거리' },
    { key: 'returning', label: '🔄 귀환' },
    { key: 'idle', label: '🅿️ 대기' },
  ];

  const filteredTrucks = filter === 'all' ? trucks : trucks.filter(t => t.type === filter);

  const handleBook = (truck) => {
    setSelectedTruck(truck);
    setShowBookingModal(true);
    setBookingStep(0);
  };

  const mockMap = (truck) => (
    <div style={{
      width: '100%', height: 120,
      background: 'linear-gradient(135deg, #f3e5f5 0%, #e8f4fd 100%)',
      borderRadius: 12, position: 'relative', overflow: 'hidden',
      marginBottom: 12
    }}>
      <svg width="100%" height="100%" style={{ position: 'absolute', opacity: 0.3 }}>
        <line x1="0" y1="60" x2="100%" y2="60" stroke="#9B59B6" strokeWidth="4"/>
        <line x1="0" y1="30" x2="100%" y2="80" stroke="#9B59B6" strokeWidth="2" strokeDasharray="8,4"/>
      </svg>
      {/* 출발지 */}
      <div style={{
        position: 'absolute', left: '10%', top: '50%', transform: 'translate(-50%,-50%)',
        background: '#8E44AD', color: 'white', borderRadius: 20, padding: '4px 10px',
        fontSize: 11, fontWeight: 700
      }}>📍 출발</div>
      {/* 트럭 아이콘 */}
      <div style={{
        position: 'absolute', left: '50%', top: '40%', transform: 'translate(-50%,-50%)',
        fontSize: 28, animation: 'moveRight 2s linear infinite'
      }}>🚚</div>
      {/* 도착지 */}
      <div style={{
        position: 'absolute', right: '10%', top: '50%', transform: 'translate(50%,-50%)',
        background: '#2980B9', color: 'white', borderRadius: 20, padding: '4px 10px',
        fontSize: 11, fontWeight: 700
      }}>🏠 도착</div>
      <style>{`@keyframes moveRight { 0% { left: 30%; } 100% { left: 70%; } }`}</style>
    </div>
  );

  return (
    <div className="page-white">
      {/* 헤더 */}
      <div style={{ background: 'linear-gradient(135deg, #8E44AD 0%, #9B59B6 100%)', padding: '20px 20px 24px' }}>
        <button
          onClick={() => navigate(-1)}
          style={{ background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: 10, padding: '8px 12px', color: 'white', cursor: 'pointer', marginBottom: 12 }}
        >← 뒤로</button>
        <div style={{ color: 'white', fontSize: 22, fontWeight: 800, marginBottom: 4 }}>
          🛣️ 공차 매칭
        </div>
        <div style={{ color: 'rgba(255,255,255,0.85)', fontSize: 13, marginBottom: 12 }}>
          이사 귀환 차량으로 최대 50% 절약!
        </div>

        {/* 핵심 장점 */}
        <div style={{ display: 'flex', gap: 8 }}>
          {[
            { icon: '💰', text: '최대 50% 절약' },
            { icon: '🛣️', text: '지방 → 서울' },
            { icon: '⚡', text: '당일 배송' },
          ].map((item, i) => (
            <div key={i} style={{
              flex: 1, background: 'rgba(255,255,255,0.15)', borderRadius: 10,
              padding: '8px', textAlign: 'center', backdropFilter: 'blur(10px)'
            }}>
              <div style={{ fontSize: 16 }}>{item.icon}</div>
              <div style={{ fontSize: 10, color: 'white', fontWeight: 600, marginTop: 2 }}>{item.text}</div>
            </div>
          ))}
        </div>
      </div>

      {/* 필터 탭 */}
      <div style={{ display: 'flex', gap: 8, padding: '16px 20px 8px', overflowX: 'auto' }}>
        {filters.map(f => (
          <button
            key={f.key}
            onClick={() => setFilter(f.key)}
            style={{
              whiteSpace: 'nowrap', padding: '8px 16px',
              border: `2px solid ${filter === f.key ? '#8E44AD' : '#E5E7EB'}`,
              borderRadius: 20, background: filter === f.key ? '#8E44AD' : 'white',
              color: filter === f.key ? 'white' : '#6B7280',
              fontWeight: 700, fontSize: 13, cursor: 'pointer'
            }}
          >{f.label}</button>
        ))}
      </div>

      {/* 용달차 목록 */}
      <div style={{ padding: '12px 20px 100px' }}>
        {/* 지도 요약 */}
        <div style={{
          background: 'linear-gradient(135deg, #f3e5f5 0%, #e8f4fd 100%)',
          borderRadius: 16, padding: 16, marginBottom: 16, position: 'relative', overflow: 'hidden'
        }}>
          <div style={{ fontWeight: 700, fontSize: 15, color: '#8E44AD', marginBottom: 8 }}>
            🗺️ 현재 이동 중인 공차
          </div>
          <div style={{
            height: 100, background: 'linear-gradient(160deg, #e8f5e9 0%, #e8f4fd 100%)',
            borderRadius: 12, position: 'relative', overflow: 'hidden'
          }}>
            <svg width="100%" height="100%" style={{ position: 'absolute', opacity: 0.4 }}>
              <line x1="0" y1="50%" x2="100%" y2="50%" stroke="#aaa" strokeWidth="6"/>
              <line x1="30%" y1="0" x2="30%" y2="100%" stroke="#aaa" strokeWidth="3"/>
              <line x1="70%" y1="0" x2="70%" y2="100%" stroke="#aaa" strokeWidth="3"/>
            </svg>
            {/* 차량 핀들 */}
            {[
              { left: '15%', top: '60%', emoji: '🚛', label: '부산' },
              { left: '40%', top: '40%', emoji: '🚚', label: '대전' },
              { left: '65%', top: '55%', emoji: '🚐', label: '인천' },
              { left: '80%', top: '35%', emoji: '🚛', label: '서울' },
            ].map((pin, i) => (
              <div key={i} style={{ position: 'absolute', left: pin.left, top: pin.top, transform: 'translate(-50%,-50%)' }}>
                <div style={{ fontSize: 20 }}>{pin.emoji}</div>
                <div style={{ fontSize: 9, fontWeight: 700, color: '#8E44AD', textAlign: 'center', background: 'rgba(255,255,255,0.8)', borderRadius: 4, padding: '1px 4px' }}>{pin.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* 공차 카드들 */}
        {filteredTrucks.map(truck => (
          <div
            key={truck.id}
            style={{
              background: 'white', borderRadius: 16, padding: 18, marginBottom: 14,
              border: `2px solid ${selectedTruck?.id === truck.id ? '#8E44AD' : '#E5E7EB'}`,
              boxShadow: selectedTruck?.id === truck.id ? '0 4px 16px rgba(142,68,173,0.2)' : '0 2px 8px rgba(0,0,0,0.04)',
              cursor: 'pointer', transition: 'all 0.2s'
            }}
            onClick={() => setSelectedTruck(truck)}
          >
            {/* 카드 헤더 */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
              <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                <div style={{
                  width: 52, height: 52, borderRadius: 14,
                  background: truck.type === 'longDistance' ? '#f3e5f5' : truck.type === 'returning' ? '#e8f8ef' : '#e8f4fd',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 26
                }}>
                  {truck.emoji}
                </div>
                <div>
                  <div style={{ fontWeight: 800, fontSize: 15, color: '#1F2937' }}>{truck.vehicle}</div>
                  <div style={{ fontSize: 12, color: '#6B7280', marginTop: 2 }}>기사: {truck.driver}</div>
                  <div style={{ color: '#F39C12', fontSize: 12, marginTop: 1 }}>⭐ {truck.rating}</div>
                </div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{
                  background: truck.type === 'longDistance' ? '#f3e5f5' : truck.type === 'returning' ? '#e8f8ef' : '#e8f4fd',
                  color: truck.type === 'longDistance' ? '#8E44AD' : truck.type === 'returning' ? '#27AE60' : '#2980B9',
                  padding: '4px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700, marginBottom: 4
                }}>
                  {truck.typeLabel}
                </div>
                <div style={{ fontSize: 18, fontWeight: 800, color: '#8E44AD' }}>
                  {truck.discountRate}% ↓
                </div>
              </div>
            </div>

            {/* 경로 시각화 */}
            <div style={{
              background: '#F9FAFB', borderRadius: 10, padding: '10px 14px',
              display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12
            }}>
              <div>
                <div style={{ fontSize: 10, color: '#9CA3AF', fontWeight: 600 }}>출발</div>
                <div style={{ fontSize: 12, fontWeight: 700, color: '#1F2937' }}>{truck.from.split('→')[0]?.trim()}</div>
              </div>
              <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 4 }}>
                <div style={{ flex: 1, height: 2, background: '#CE93D8' }}/>
                <span style={{ fontSize: 16 }}>🚚</span>
                <div style={{ flex: 1, height: 2, background: '#2196F3' }}/>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: 10, color: '#9CA3AF', fontWeight: 600 }}>도착</div>
                <div style={{ fontSize: 12, fontWeight: 700, color: '#1F2937' }}>{truck.from.split('→')[1]?.trim()}</div>
              </div>
            </div>

            {/* 상세 정보 */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 12 }}>
              {[
                { label: '예상 도착', val: truck.eta },
                { label: '번호판', val: truck.plateNo },
                { label: '적재 상태', val: truck.loadText },
                { label: '절감 효과', val: `최대 ${truck.discountRate}% 절약` },
              ].map((item, i) => (
                <div key={i} style={{ background: '#F9FAFB', borderRadius: 8, padding: '8px 10px' }}>
                  <div style={{ fontSize: 10, color: '#9CA3AF', fontWeight: 600, marginBottom: 2 }}>{item.label}</div>
                  <div style={{ fontSize: 12, fontWeight: 700, color: '#1F2937' }}>{item.val}</div>
                </div>
              ))}
            </div>

            {/* 적재 가용 바 */}
            <div style={{ marginBottom: 12 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                <span style={{ fontSize: 12, color: '#6B7280' }}>현재 적재율</span>
                <span style={{ fontSize: 12, fontWeight: 700, color: '#8E44AD' }}>{truck.loadCapacity}</span>
              </div>
              <div style={{ height: 8, background: '#E5E7EB', borderRadius: 4, overflow: 'hidden' }}>
                <div style={{ width: truck.loadCapacity, height: '100%', background: 'linear-gradient(90deg, #8E44AD, #9B59B6)', borderRadius: 4 }}/>
              </div>
            </div>

            <button
              onClick={(e) => { e.stopPropagation(); handleBook(truck); }}
              style={{
                width: '100%', padding: '12px', borderRadius: 12,
                background: 'linear-gradient(135deg, #8E44AD 0%, #9B59B6 100%)',
                color: 'white', border: 'none', fontWeight: 700, cursor: 'pointer',
                fontSize: 14
              }}
            >
              이 차량에 배송 요청하기 →
            </button>
          </div>
        ))}

        {/* 용달차 등록 유도 */}
        <div style={{
          background: 'linear-gradient(135deg, #8E44AD 0%, #9B59B6 100%)',
          borderRadius: 16, padding: 20, marginTop: 8
        }}>
          <div style={{ color: 'white', fontWeight: 800, fontSize: 16, marginBottom: 4 }}>
            🚚 용달차 기사님이신가요?
          </div>
          <div style={{ color: 'rgba(255,255,255,0.85)', fontSize: 13, marginBottom: 12 }}>
            공차 매칭으로 귀환 손실을 없애고 추가 수익을 올리세요!
          </div>
          <button
            onClick={() => navigate('/truck-register')}
            style={{
              background: 'white', color: '#8E44AD', border: 'none',
              borderRadius: 10, padding: '10px 20px', fontWeight: 700, cursor: 'pointer', fontSize: 13
            }}
          >
            🚚 차량 등록하기 →
          </button>
        </div>
      </div>

      {/* 배송 요청 모달 */}
      {showBookingModal && selectedTruck && (
        <div className="modal-overlay" onClick={() => { setShowBookingModal(false); setBookingStep(0); }}>
          <div className="modal-sheet" onClick={e => e.stopPropagation()}>
            <div className="modal-handle"/>
            {bookingStep === 0 && (
              <>
                <div style={{ fontWeight: 800, fontSize: 18, marginBottom: 4 }}>
                  🚚 {selectedTruck.vehicle}에 배송 요청
                </div>
                <div style={{ fontSize: 13, color: '#6B7280', marginBottom: 16 }}>
                  {selectedTruck.from} 이동 차량
                </div>

                <div style={{ background: '#f3e5f5', borderRadius: 12, padding: 14, marginBottom: 16 }}>
                  <div style={{ fontSize: 13, color: '#5B2C6F', lineHeight: 1.7 }}>
                    📍 차량 경로: <strong>{selectedTruck.route}</strong><br/>
                    ⏰ 예상 도착: <strong>{selectedTruck.eta}</strong><br/>
                    💰 절약 효과: <strong>최대 {selectedTruck.discountRate}% 할인</strong>
                  </div>
                </div>

                <div className="input-group">
                  <label className="input-label">📦 픽업 주소 (판매자 위치)</label>
                  <input className="input-field" value={pickup} onChange={e => setPickup(e.target.value)} placeholder="예: 서울 마포구 합정동 123" />
                </div>

                <div className="input-group">
                  <label className="input-label">🏠 배송 주소 (내 집)</label>
                  <input className="input-field" value={delivery} onChange={e => setDelivery(e.target.value)} placeholder="예: 서울 은평구 응암동 456" />
                </div>

                <button
                  onClick={() => setBookingStep(1)}
                  disabled={!pickup || !delivery}
                  style={{
                    width: '100%', padding: '14px', borderRadius: 12,
                    background: pickup && delivery ? '#8E44AD' : '#E5E7EB',
                    color: pickup && delivery ? 'white' : '#9CA3AF',
                    border: 'none', fontWeight: 700, cursor: pickup && delivery ? 'pointer' : 'not-allowed'
                  }}
                >
                  요금 확인하기 →
                </button>
              </>
            )}

            {bookingStep === 1 && (
              <>
                <div style={{ fontWeight: 800, fontSize: 18, marginBottom: 16 }}>💰 예상 요금</div>
                <div style={{
                  background: 'linear-gradient(135deg, #8E44AD, #9B59B6)',
                  borderRadius: 16, padding: 20, color: 'white', textAlign: 'center', marginBottom: 16
                }}>
                  <div style={{ fontSize: 13, opacity: 0.8, marginBottom: 4 }}>공차 매칭 특가</div>
                  <div style={{ fontSize: 36, fontWeight: 800 }}>18,000원</div>
                  <div style={{ fontSize: 13, opacity: 0.7, textDecoration: 'line-through' }}>일반 가격 32,000원</div>
                  <div style={{ marginTop: 8, background: 'rgba(255,255,255,0.2)', borderRadius: 20, padding: '4px 16px', display: 'inline-block', fontSize: 12, fontWeight: 700 }}>
                    🎉 {selectedTruck.discountRate}% 절약
                  </div>
                </div>

                {[
                  { label: '기본 요금', val: '10,000원' },
                  { label: '거리 요금 (4km)', val: '8,000원' },
                  { label: '공차 매칭 할인', val: `-${Math.round(18000 * selectedTruck.discountRate / 100).toLocaleString()}원` },
                ].map((item, i) => (
                  <div key={i} className="info-row">
                    <span className="info-key">{item.label}</span>
                    <span className="info-val" style={{ color: item.val.startsWith('-') ? '#27AE60' : undefined }}>{item.val}</span>
                  </div>
                ))}

                <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
                  <button
                    onClick={() => setBookingStep(0)}
                    style={{ flex: 1, padding: '14px', borderRadius: 12, background: 'white', border: '2px solid #E5E7EB', fontWeight: 700, cursor: 'pointer' }}
                  >수정</button>
                  <button
                    onClick={() => {
                      setShowBookingModal(false);
                      setBookingStep(0);
                      navigate('/booking', { state: { serviceType: 'delivery', truckId: selectedTruck.id, price: { total: 18000 } } });
                    }}
                    style={{ flex: 2, padding: '14px', borderRadius: 12, background: '#8E44AD', color: 'white', border: 'none', fontWeight: 700, cursor: 'pointer' }}
                  >18,000원으로 예약하기</button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default TruckMatchPage;
